<template>
  <div class="home">
    <!-- 成绩查询 悬浮窗 -->
    <!-- <div class="queryFixed" @click="queryList"><p>成绩查询</p></div> -->
    <!-- 顶部轮播图 -->
    <div class="maininfo">
      <!-- <el-carousel :autoplay = "true" :interval="15000" > -->
      <el-carousel :autoplay="true" :interval="10000">
        <el-carousel-item v-for="item in imgone" :key="item.id">
          <img :src="item.imgPath" alt="" @click="topage(item)" />
        </el-carousel-item>
      </el-carousel>
      <!-- <el-carousel indicator-position="outside" 指示器的位置在外面 >-->
    </div>

    <!-- 协会公告 -->
    <!-- 国际象棋新闻 -->
    <div class="listinfo">
      <div class="widthSet">
        <div class="left">
          <div class="top">
            <div class="leftson">
              <h3>协会公告</h3>
              <p>
                <span>ASSOCIATION</span> <span class="green">ANNOUNCEMENT</span>
              </p>
            </div>
            <div class="rightson">
              <p>更多</p>
              <button @click="tonotice">
                <i class="el-icon-arrow-right"></i>
              </button>
            </div>
          </div>

          <ul class="newnotice">
            <!-- <li v-for="item in 5" :key="item">
            <p>{{item}}-2022沈阳市少儿国际象棋公开挑战赛</p><p>7.20</p>
          </li> -->
            <li
              class="itemshadow aniMate"
              v-for="item in noticelist"
              :key="item.id"
              @click="getnoticedetailsdata(item.noticeId)"
            >
              <p v-if="item.title && item.title !== '2'">{{ item.title }}</p>
              <p v-else>协会公告</p>

              <p>{{ item.publishDate | yymmdd }}</p>
            </li>
          </ul>
        </div>

        <!-- 国际象棋新闻 -->
        <div class="right">
          <div class="top">
            <div class="leftson">
              <h3>国际象棋新闻</h3>
              <p><span>CHESS CUBE</span> <span class="green">NEWS</span></p>
            </div>
            <div class="rightson">
              <p>更多</p>
              <button @click="tonews">
                <i class="el-icon-arrow-right"></i>
              </button>
            </div>
          </div>

          <ul class="newnotice">
            <!-- <li v-for="item in 5" :key="item">
            <p>{{item}}-2022沈阳市少儿国际象棋公开挑战赛</p><p>7.20</p>
          </li> -->
            <li
              class="itemshadow aniMate"
              v-for="item in newslist"
              :key="item.id"
              @click="getnewsdetailsdata(item)"
            >
              <p class="maxwidth">{{ item.title }}</p>
              <p>{{ item.publishDate | yymmdd }}</p>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- 合作伙伴 -->
    <div class="partinfo">
      <p>沈阳市国际象棋运动协会合作伙伴</p>
      <!-- <p>Cooperative partner  OOPERATIVE PARTNER</p> -->
      <p>COOPERATIVE PARTNER</p>
    </div>

    <!-- 底部轮播图  -->
    <div class="footerinfo">
      <ul class="footul">
        <li
          class="footli cursorPointer"
          v-for="item in imgtwo"
          :key="item.id"
          @click="toLink(item.linkPath)"
        >
          <img :src="item.imgPath" alt="" />
        </li>
      </ul>

      <!-- <div class="prev" @click='go("prev")'>
        <button><i class="el-icon-arrow-left"></i></button>
      </div>
      <div>
        <el-carousel ref="cardshow" height="150px" :autoplay = "true" :interval="4000" indicator-position="none" arrow="never">
          <el-carousel-item v-for="item in imgtwo" :key="item.id" >
            <img :src="item.src" alt="">
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="next" @click='go("next")'>
        <button><i class="el-icon-arrow-right"></i></button>
      </div> -->
      <a
        ref="aclick"
        v-show="false"
        target="_blank"
        href="https://www.chesscoacher.com/"
        >众弈世界</a
      >
    </div>
  </div>
</template>

<script>
  import request from '../utils/request'
  export default {
    name: 'Home',
    components: {},
    data() {
      return {
        noticelist: [
        ], //协会公告
        newslist: [], //新闻资讯
        // banner虚拟数据
        imgone: [{
            id: 3,
            src: require("@/assets/bannerall/banner3.png")
          },
          {
            id: 1,
            src: require("@/assets/bannerall/newbanner1.png")
          },
          {
            id: 2,
            src: require("@/assets/bannerall/newbanner2.png")
          },
          // {
          //   id:3,
          //   src:require("@/assets/bannerall/banner3.png")
          // },
        ],

        // 底部合作伙伴
        imgtwo: [

          {
            id: 2,
            name: "优尔",
            src: require("@/assets/bannerall/yr.png")
          },
          {
            id: 4,
            name: "众弈",
            src: require("@/assets/bannerall/zy.png")
          },
          {
            id: 5,
            name: "国际象棋俱乐部",
            src: require("@/assets/bannerall/mf.png")
          },
          {
            id: 3,
            name: "沈阳棋院",
            src: require("@/assets/bannerall/syqy.png")
          },

          {
            id: 1,
            name: "基金会",
            src: require("@/assets/bannerall/jjh.png")
          },
        ],
       
      }
    },
    created() {
      this.$store.commit("updatetabIndexActive", "1")
      // 进入页面 就将页面滚动到最顶部   可以解决多个路由页面共用一个滚动容器的bug
      document.documentElement.scrollTop = 0
      // 请求banner数据
      this.getbanner()
      // 请求partner数据
      this.getPartner()
      // 请求协会公告列表
      this.getnoticedata()
      // 请求国际象棋新闻列表
      this.getnewsdata()
      // 测试数组截取
      // this.handlelist()
    },

    methods: {
      // 悬浮成绩查询
      queryList() {

        // 跳转至赛事活动页
        this.$router.push({
          name: "move",
          query: {
            queryRandomNum: 1
          }
        })
        this.$store.commit("updatetabIndexActive", "3")

      },
      // 获取协会公告列表
      async getnoticedata() {
        try {
          const {
            data
          } = await request({
            method: "POST",
            url: `/common/NoticeInfo/list`,
          })
          if (data.code === 200) {
            this.noticelist = data.rows.slice(0, 5) //截取前五项
          } else {
            if (data.msg) {
              this.$message.error(data.msg);
              return
            }
            this.$message.error("获取赛事列表失败")
          }
        } catch (error) {
          this.$message.error("数据请求失败，请重试")
        }

      },
      // 获取新闻资讯列表
      async getnewsdata() {
        // 请求列表数据
        const {
          data
        } = await request({
          method: "POST",
          url: `/common/NewsInfo/list`,
        })
        console.log("首页获取新闻列表成功")
        if (data.rows.length < 5) {
          this.newslist = data.rows
        } else {
          this.newslist = data.rows.slice(0, 5)
        }
        console.log(data.rows)
      },

      async getnoticedetailsdata(id) {
        // this.$router.push({
        //   path: "/Notice"
        // })
        // this.$store.commit("updatetabIndexActive", "2")
        // document.documentElement.scrollTop = 0
        // 请求列表详情数据
        const {
          data
        } = await request({
          method: "POST",
          url: `/common/NoticeInfo/getInfo`,
          params: {
            id: id
          }
        })
        console.log("获取公告详情成功")
        console.log(data.data)
        // 存入vuex
        if (data.data) {
          // 如果详情对象有值 则将该机构详情对象数据存储到vuex中 供机构详情页使用
          await this.$store.commit("updateNoticedetails", data.data)
        } else {
          // 如果详情对象无值 则传入空对象
          await this.$store.commit("updateNoticedetails", {})
        }
        // 将 index索引值存入vuex
        this.$store.commit("updatetabIndexActive", "2")
        // 跳转路由
        this.$router.push({
          path: '/Noticedetails'
        })
      },
      async getnewsdetailsdata(obj) {
        if(obj.newsLink) {
      // 如果有新闻链接 则直接跳转
      window.open(obj.newsLink, "_blank");
      } else {
        // 请求列表详情数据
        const {
          data
        } = await request({
          method: "POST",
          url: `/common/NewsInfo/getInfo`,
          params: {
            id: obj.id
          }
        })
        console.log("获取新闻详情成功")
        console.log(data.data)
        // 存入vuex
        if (data.data) {
          // 如果详情对象有值 则将该机构详情对象数据存储到vuex中 供机构详情页使用
          await this.$store.commit("updatenewsdetails", data.data)
        } else {
          // 如果详情对象无值 则传入空对象
          await this.$store.commit("updatenewsdetails", {})
        }
        // 将 index索引值存入vuex
        this.$store.commit("updatetabIndexActive", "4")
        // 跳转路由
        this.$router.push({
          path: '/newsdetails'
        })
      }
      },
      // 获取banner图
      async getbanner() {
        try {
          const {
            data
          } = await request({
            url: `/common/BannerInfo/list`,
            method: "POST",
            params: {
              client: "pc"
            }
          })
          if (data.code === 200) {
            this.imgone = data.rows
          } else {
            if (data.msg) {
              this.$message.error(data.msg);
              return
            }
            this.$message.error("获取数据失败")
          }

        } catch (error) {
          this.$message.error("数据请求失败，请重试")
        }
      },
      // 获取合作伙伴图
      async getPartner() {
        try {
          const {
            data
          } = await request({
            url: `/common/partner/list`,
            method: "POST",
          })
          if (data.code === 200) {
            this.imgtwo = data.rows
          } else {
            if (data.msg) {
              this.$message.error(data.msg);
              return
            }
            this.$message.error("获取数据失败")
          }

        } catch (error) {
          this.$message.error("数据请求失败，请重试")
        }

      },



      tonotice() {
        // 先滚动置0 再跳转路由
        document.documentElement.scrollTop = 0
        this.$store.commit("updatetabIndexActive", "2")
        this.$router.push({
          path: "/Notice"
        })
      },
      tonews() {
        // 先滚动置0 再跳转路由
        document.documentElement.scrollTop = 0
        this.$store.commit("updatetabIndexActive", "4")
        this.$router.push({
          path: "/news"
        })
      },
      // 轮播图点击跳转事件
      go(type) {
        if (type === "prev") {
          this.$refs.cardshow.prev()
        } else {
          this.$refs.cardshow.next()
        }
      },
      // 轮播图点击跳转
      topage(item) {
        document.documentElement.scrollTop = 0
        window.open(item.linkPath)
        // if (id == 1) {
        //   document.documentElement.scrollTop = 0
        //   this.$router.push({ path: "/Notice" })
        //   this.$store.commit("updatetabIndexActive", "2")
        // }
        // if (id == 3) {
        //   document.documentElement.scrollTop = 0
        //   // 调用a链接（众弈世界）的点击事件
        //   this.$refs.aclick.click()
        // }
        // if (id == 2 || id == 4) {
        //   document.documentElement.scrollTop = 0
        //   this.$router.push({ path: "/move" })
        //   this.$store.commit("updatetabIndexActive", "3")
        // }
      },
      //合作伙伴跳转  window.location.href = "https://www.sport.gov.cn/"
      // toLink (name) {
      //   const idMap = {
      //     "众弈": () => { window.open("https://www.chesscoacher.com/") },
      //     "优尔": () => { window.open("http://www.yoercn.com/") },
      //     "沈阳棋院": () => { window.open("https://aiqicha.baidu.com/company_detail_25733081903387") },
      //     "基金会": () => { window.open("http://www.sysjyjjh.cn/") },
      //     "国际象棋俱乐部": () => { window.open("http://www.mofang123.cn/") }
      //   }
      //   idMap[name] ? idMap[name]() : console.log("跳转异常")
      // }
      toLink(name) {
        window.open(name)
      }
    },
  }

</script>

<style lang="less" scoped>
.queryFixed {
  position: fixed;
  left: 5px;
  top: 450px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  width: 80px;
  height: 80px;
  background-color: #fe80b1;
  color: #ffffff;
  font-size: 16px;
  cursor: pointer;
  -webkit-transition: background-color 0.8s, font-size 0.4s,
    -webkit-transform 1s;
  /* For Safari 3.1 to 6.0 */
  transition: background-color 0.8s, font-size 0.4s, transform 1s;
}

.queryFixed:hover {
  background-color: #76afec;
  font-size: 14px;
  // border: 2px solid yellow;
}

// #FE80B1, #76AFEC
// .home{
//background-color: #EFEFEF;
// }
.green {
  color: #33ab93;
}

// 顶部轮播图样式
.maininfo {
  display: flex;
  justify-content: center;
  background-color: #fff;
}

.el-carousel__item img {
  width: 100%;
}

/deep/ .el-carousel__container {
  width: 1341px;
  height: 375px;
  // width: 1920px;
  // min-height: 600px;
}

/deep/ .maininfo .el-carousel__arrow--left {
  width: 40px;
}

/deep/ .maininfo .el-carousel__arrow--right {
  width: 40px;
}

/deep/ .maininfo .el-icon-arrow-left {
  font-size: 30px;
}

/deep/ .maininfo .el-icon-arrow-right {
  font-size: 30px;
}

// 顶部轮播图样式

// 公告新闻列表样式↓↓↓
.listinfo {
  background-color: #ffffff;
  margin: 25px 0px;
  height: 570px;
  padding: 45px 0px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.widthSet {
  width: 1341px;
  display: flex;
  justify-content: space-between;
}

@keyframes myfirst {
  0% {
    opacity: 0;
    margin-top: 150px;
  }

  25% {
  }

  50% {
  }

  75% {
  }

  100% {
    margin-top: 0px;
    //  transform:rotateY(180deg);
    //  -webkit-transform: rotateY(360deg); /* Safari 与 Chrome */
    //  opacity: 1;
  }
}

.left,
.right {
  animation: myfirst 1.5s;
  -moz-animation: myfirst 1.5s;
  /* Firefox */
  -webkit-animation: myfirst 1.5s;
  /* Safari and Chrome */
  -o-animation: myfirst 1.5s;
  /* Opera */
}

.top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 580px;
}

.leftson {
  text-align: start;
}

.leftson h3 {
  font-size: 30px;
}

.leftson p {
  font-size: 24px;
  font-weight: bold;
}

.rightson {
  display: flex;
  align-items: center;
}

.rightson p {
  font-size: 20px;
  margin-right: 6px;
  font-weight: bold;
}

.rightson button {
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  border: 1px solid #030303;
  background-color: white;

  i {
    padding-top: 2px;
    padding-left: 2px;
  }
}

.newnotice {
  margin: 20px 0px 30px;
}

.newnotice li {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  padding: 0px 20px;
  // width: 650px;
  height: 60px;
  font-size: 20px;
  color: #ffffff;
  // background: #2E4051;
  background-image: linear-gradient(to right, #fe80b1, #76afec);
  -webkit-transition: font-size 0.8s, border 0.2s, -webkit-transform 1s;
  /* For Safari 3.1 to 6.0 */
  transition: font-size 0.8s, border 0.2s, transform 1s;
}

.newnotice li:hover {
  font-size: 22px;
  border: 2px solid yellow;
}

// .newnotice li:last-child {
//   margin-bottom: 0px;
// }

// 公告新闻列表样式↑↑↑

// 合作伙伴 ↓↓↓
.partinfo {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 150px;
  background-image: url(../assets/css/img/bg.jpg);
}

.partinfo p {
  font-size: 35px;
  color: #ffffff;
}

.partinfo p:last-child {
  font-size: 24px;
}

// 合作伙伴 ↑↑↑

// 底部轮播图待替换 ↓↓↓
.footerinfo {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 260px;
  background-color: #ffffff;

  margin: 25px 0px;
}

// 静态ul li
.footul {
  height: 220px;
  display: flex;
  width: 1341px;
  // justify-content: flex-start;
}

.footli {
  background-color: white;
  height: 220px;
  width: 240px;
  // width: 100px;
  display: flex;
  // align-items: flex-end;
  align-items: center;
  justify-content: center;
}

.footli img {
  width: 190px;
  -webkit-transition: width 0.8s;
  /* For Safari 3.1 to 6.0 */
  transition: width 0.8s;
}

.footli img:hover {
  width: 240px;

  // background-image: linear-gradient(to right, #FE80B1,rgba(0,0,0,0) , #76AFEC,);
}

.footli:hover {
  border-bottom: 2px solid #fe80b1;
}

// 轮播图
.footerinfo .prev {
  width: 60px;
  height: 60px;
  border: 1px solid white;
  margin-right: 109px;
  line-height: 60px;
}

.footerinfo .prev .el-icon-arrow-left {
  font-size: 20px;
}

.footerinfo .next {
  width: 60px;
  height: 60px;
  border: 1px solid white;
  margin-left: 109px;
  line-height: 60px;
}

.footerinfo .next .el-icon-arrow-right {
  font-size: 20px;
}

.footerinfo .prev button,
.footerinfo .next button {
  width: 60px;
  height: 60px;
}

// 轮播图具体样式  轮播图样式调整思路
// 标签上的高度、.el-carousel的宽度、.el-carousel__item及.el-carousel__container的宽高
.footerinfo .el-carousel {
  width: 260px;
}

//  .footerinfo .el-carousel .el-carousel__item{
//   //  height: 100px;
//   //  width: 100px;
//  }

// 底部轮播图 待替换↑↑↑
.maxwidth {
  width: 400px;
  text-align: left;
  widows: 100%;
  overflow: hidden;
  white-space: nowrap;
  -o-text-overflow: ellipsis;
  text-overflow: ellipsis;
}
</style>
